import styleFn from '../util'
const display = styleFn({propName: 'display'})
export default display
